import React from 'react';
import { Loader2 } from 'lucide-react';

const STATUS = {
  draft: { label: 'Draft', cls: 'bg-[#27272A] text-[#A1A1AA] border-[#3F3F46]' },
  scheduled: { label: 'Scheduled', cls: 'bg-[#6366F1]/10 text-[#6366F1] border-[#6366F1]/30' },
  running: { label: 'Launching…', cls: 'bg-amber-500/10 text-amber-400 border-amber-500/30', spin: true },
  live: { label: 'Live', cls: 'bg-[#06C755]/10 text-[#06C755] border-[#06C755]/30' },
  failed: { label: 'Failed', cls: 'bg-red-500/10 text-red-400 border-red-500/30' },
  rolled_back: { label: 'Rolled back', cls: 'bg-[#27272A] text-[#A1A1AA] border-[#3F3F46]' },
  missed: { label: 'Missed', cls: 'bg-amber-500/10 text-amber-400 border-amber-500/30' },
  cancelled: { label: 'Cancelled', cls: 'bg-[#27272A] text-[#A1A1AA] border-[#3F3F46]' },
  superseded: { label: 'Superseded', cls: 'bg-[#27272A] text-[#A1A1AA] border-[#3F3F46]' },
};

export function CampaignStatusBadge({ status }) {
  const s = STATUS[status] || { label: status || 'Unknown', cls: STATUS.draft.cls };
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${s.cls}`}
      data-testid={`campaign-status-${status}`}
    >
      {s.spin && <Loader2 className="w-3 h-3 animate-spin" />}
      {s.label}
    </span>
  );
}

export default CampaignStatusBadge;
